import list_card from './list_card.vue';
import axios  from 'axios';

export default {
    name: 'left_bdcsld_list',


    /** 本页面用到的组件 */
    components: {
        list_card,
    },

    /** 本页面的属性 */
    data () {
        return {
            res_list:[],
        }
    },

    /** 计算属性 */
    computed: {},

    /** 构建页面时 */
    mounted () {

        // 获取列表数据
        this.get_list();
    
    },

    /** 每次进入页面时 */
    activated () {

    },

    /** 每次退出页面时 */
    deactivated () {

    },

    /** 本页面可用的方法 */
    methods: {

        // 获取列表数据
        get_list(){
            axios.get('https://app-pad.nnrig.com/proxy/map/08db3fa5-dbcb-45c4-8ec9-04dde9b7de28/MapServer/0/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=false&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=pjson')
            .then(
                response =>{
                    //console.log(response.data);
                    this.res_list = response.data.features;
                    this.res_list = this.res_list.filter(this.filter_type);
                    this.res_list.sort(this.sort_XH);
                }
            )
            .catch(
                err => {   
                    console.log(err);
                }
            )
        },

        //根据属性序号排序
        sort_XH(a,b){
            return a.attributes.XH - b.attributes.XH;
        },
        //根据属性Type筛选
        filter_type(a){
            return (a.attributes.Type == "不动产登记中心受理点");
        },
    },
}


// WEBPACK FOOTER //
// ./src/components/zwfwmap-pc/left_bdcsld_list/left_bdcsld_list.js